<template>
  <div>
    <table class="asd-table">
      <tr class="table-heading">
        <th>
          <button class="asd-btn-confirm"
                  v-help.mouse="`Pridat synchronizaci`"
                  @click="addEntry"
          >
            <i class="fas fa-plus"></i>
          </button>
        </th>
        <th>Název</th>
      </tr>
      <tr v-for="(e, $index) in entries"
          :key="e.name"
      >
        <td>
          <button type="button"
                  class="asd-btn-edit"
                  v-help.mouse="`Editovat synchronizaci`"
                  @click="currentEntryId = $index"
          >
            <i class="fas fa-pencil-alt"></i>
          </button>
          <button type="button"
                  class="asd-btn-delete"
                  v-help.mouse="`Smazat synchronizaci`"
                  @click="removeEntry($index)"
          >
            <i class="fas fa-trash"></i>
          </button>
        </td>
        <td>{{ e.name }}</td>
      </tr>
    </table>
    <FlexibeeEntry v-if="currentEntry !== undefined"
                   :key="currentEntryId"
                   v-model="currentEntry"
                   class="asd-form"
                   @input="saveEntries"
    ></FlexibeeEntry>
  </div>
</template>

<script>
import { get, filter } from 'lodash'
import FlexibeeEntry from './entry'

export default {
    name: 'FlexibeeEditor',
    components: {
        FlexibeeEntry,
    },
    data() {
        return {
            currentEntryId: 0,
            entries: [],
        }
    },
    computed: {
        currentEntry: {
            get() {
                return this.entries[this.currentEntryId]
            },
            set(value) {
                this.$set(this.entries, this.currentEntryId, value)
            },
        },
    },
    mounted() {
        this.entries = get(this.$store.getters.currentUser, 'company.settings.sync', [])
    },
    methods: {
        addEntry() {
            this.entries.push({})
            this.currentEntryId = this.entries.length - 1
        },
        async removeEntry(id) {
            try {
                await this.$prompt('Opravdu chcete nastavení smazat?')
                this.$set(this, 'entries', filter(this.entries, (e, i) => i !== id))
            } catch (e) {

            }
        },
        async saveEntries() {
            try {
                await this.$store.dispatch('saveCurrentUserCompanySyncs', this.entries)
                this.flash('Uloženo', 'success', {
                    timeout: 1500,
                })
            } catch (e) {
                this.flash(`Nepovedlo se [${e.message}]`, 'error')
            }
        },
    },
}
</script>
